import { images } from "./images";

export const sectors = [
  {
    slug: "construction-development",
    name: "Construction & Development",
    blurb: "Guarding active builds, laydown yards and pre-sales centres from groundbreak to handover.",
    copy: "Construction sites concentrate valuable tools, copper, fuel and equipment in open, changing perimeters. Our construction security programs combine static guards, mobile patrols, gate control and fire watch so theft and vandalism never become line items on your budget.",
    services: ["construction-site-security", "mobile-security-patrol", "fire-watch-security", "cctv-remote-monitoring"],
    image: images.sectorConstruction,
  },
  {
    slug: "commercial-real-estate",
    name: "Commercial Real Estate & Office Towers",
    blurb: "Lobby security, access control and tenant safety for offices, towers and business parks.",
    copy: "Class-A office space demands Class-A security. We staff lobbies with hospitality-trained guards, manage access control and visitor flow, and give property managers the incident reporting they need to keep tenants renewing.",
    services: ["commercial-office-security", "concierge-front-desk-security", "cctv-remote-monitoring", "alarm-response-keyholding"],
    image: images.sectorCommercial,
  },
  {
    slug: "retail-shopping-centres",
    name: "Retail & Shopping Centres",
    blurb: "Loss prevention, uniformed deterrence and customer-safe guarding for retail environments.",
    copy: "Retail shrinkage climbs every year, and organized theft crews target understaffed stores. Our loss prevention officers and uniformed guards protect margin without compromising the shopping experience your customers expect.",
    services: ["retail-loss-prevention", "uniformed-security-guards", "cctv-remote-monitoring", "event-security"],
    image: images.surveillance,
  },
  {
    slug: "healthcare",
    name: "Healthcare & Hospitals",
    blurb: "De-escalation-trained security for hospitals, clinics, care homes and health campuses.",
    copy: "Healthcare facilities face rising workplace violence alongside strict privacy and safeguarding duties. Our healthcare guards are trained in de-escalation, patient watch and emergency codes, protecting staff, patients and visitors with equal care.",
    services: ["healthcare-facility-security", "uniformed-security-guards", "cctv-remote-monitoring", "alarm-response-keyholding"],
    image: images.guard,
  },
  {
    slug: "education-campuses",
    name: "Education & Campuses",
    blurb: "Safeguarding-first security for schools, colleges and universities.",
    copy: "Educational institutions need security that students trust and administrators can document. From visitor management at elementary schools to residence patrols on university campuses, our vetted guards keep learning environments safe and welcoming.",
    services: ["school-campus-security", "mobile-security-patrol", "event-security", "cctv-remote-monitoring"],
    image: images.commercial,
  },
  {
    slug: "hospitality-hotels",
    name: "Hospitality & Hotels",
    blurb: "Guest-first protection for hotels, resorts, restaurants and entertainment venues.",
    copy: "In hospitality, security failures become reviews. Our hotel and venue guards protect guests, staff and reputation with a service-first approach — firm when the situation demands it, invisible when it doesn't.",
    services: ["hotel-hospitality-security", "concierge-front-desk-security", "event-security", "cctv-remote-monitoring"],
    image: images.guard,
  },
  {
    slug: "industrial-warehousing",
    name: "Industrial & Warehousing",
    blurb: "Gatehouse, yard and inventory protection for plants, warehouses and distribution hubs.",
    copy: "Industrial operations run on tight margins and tighter schedules. Our gatehouse control, yard patrols and trailer verification protect inventory and equipment while keeping freight moving without delay.",
    services: ["industrial-warehouse-security", "mobile-security-patrol", "traffic-control-parking-enforcement", "cctv-remote-monitoring"],
    image: images.construction,
  },
  {
    slug: "residential-property-management",
    name: "Residential & Property Management",
    blurb: "Concierge, courtesy patrols and amenity security for condos and residential communities.",
    copy: "Property managers answer to boards and residents every day. Our residential programs — concierge, patrol and amenity coverage — reduce complaints, protect common assets and make buildings places people are proud to live.",
    services: ["residential-condo-security", "concierge-front-desk-security", "mobile-security-patrol", "alarm-response-keyholding"],
    image: images.commercial,
  },
  {
    slug: "events-entertainment",
    name: "Events & Entertainment",
    blurb: "Crowd management and licensed guards for festivals, concerts, sports and corporate events.",
    copy: "One security failure can end an event brand. We plan and staff event security end to end — screening, crowd flow, VIP protection and emergency response — so organizers deliver shows people remember for the right reasons.",
    services: ["event-security", "vip-executive-protection", "traffic-control-parking-enforcement", "uniformed-security-guards"],
    image: images.guard,
  },
  {
    slug: "transportation-logistics",
    name: "Transportation & Logistics",
    blurb: "Supply-chain security, escorts and yard protection for freight and fleet operations.",
    copy: "Cargo theft is among the fastest-growing property crimes in Canada. Our logistics security covers the full chain — yard control, seal verification, escorted loads and documented handoffs — so freight arrives intact.",
    services: ["logistics-transport-escort", "industrial-warehouse-security", "mobile-security-patrol", "cctv-remote-monitoring"],
    image: images.patrol,
  },
];

export const sectorBySlug = Object.fromEntries(sectors.map((s) => [s.slug, s]));
